<template>
  <modal :show="show" @close="close">
    <v-flex slot="title">{{ !!id ? 'Edytuj pracownika' : 'Dodaj pracownika' }}</v-flex>

    <profile-form :schema="$schema" :simple="true" :edit="!!id" :show="show"></profile-form>

    <v-layout slot="actions">
      <v-spacer></v-spacer>

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { mapState } from 'vuex';
import { WSchema } from '@witkac/vuetify-components';
import { ProfileType, SessionStorage } from '@witkac/kartamiejska-shared';

import schema from '@/schemas/employee.schema';
import modal from '@/components/material/Modal';
import ProfileForm from '../../profile/ProfileForm';
import { manageMixin } from '@/mixins/manage';

const emptyData = () => ({
  login: '',
  partnerId: parseInt(sessionStorage.getItem(SessionStorage.PARTNER_ID), 10),
  profile: {
    firstName: '',
    lastName: '',
    type: ProfileType.PARTNER,
    email: '',
    mainImage: null
  }
});

export default {
  components: { modal, ProfileForm },
  mixins: [manageMixin('employees', {}, emptyData)],
  schema,
  props: {
    id: { type: String, required: false }
  },
  methods: {
    // @vuese
    // pobiera identyfikator pracownika
    getId() {
      return this.stateData.profile.id;
    },

    // @vuese
    // aktualizacja pracownika
    update() {
      this.model.profile.userId = this.id;
      this.$emit('update', {
        id: this.getId(),
        ...this.model
      });
    }
  }
};
</script>
